module.exports = __webpack_public_path__ + "img/lit_telegram.a4fa1659.png";